import type { NavigationEntry } from "@positive/ui";
import "@ui5/webcomponents-icons/dist/building.js";

import { organizationPermissions } from "./permissions";

/**
 * Companies and branches in the navigation registry: Master Data owns companies and branches (module map), so the
 * screen sits in the Master data group, under "Setup & tools" with the other setup screens (UX11).
 */
export const masterDataOrganizationNavigation: readonly NavigationEntry[] = [
  {
    key: "md.companies",
    subGroup: "setupTools",
    labelKey: "nav.companies",
    icon: "building",
    path: "/md/companies",
    permission: organizationPermissions.companyView,
  },
];
